import React, {useState, useEffect, useRef, useContext, useCallback} from 'react';
import useKeyPress from '../../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../../views/textNumberEntryView';
import NumberView from '../../../views/numberTNView';
import MenuContext from '../../../../context/menuContext';
import ValuesContext from '../../../../context/valuesContext';

function SetpointBTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);
  const {selected, setDisableMenu} = useContext(MenuContext);
  const {values, onUpdateValues} = useContext(ValuesContext);

  const onRightHold = useCallback(
    result => {
      setDisableMenu(true);
      onExit();
      onUpdateValues(selected.id, result);
      setTimeout(() => setDisableMenu(false), 500);
    },
    [value],
  );

  return (
    <NumberView
      chars={numbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={2}
      defaultKey4={12}
      defaultKey5={2}
      defaultKey6={1}
      defaultKey7={14}
      defaultKey8={2}
      defaultKey9={12}
      defaultKey10={2}
      defaultKey11={0}
      defaultKey12={2}
      onSave={onRightHold}
      onLeftHold={onExit}
      title="Setpoint B"
      caption=""
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default SetpointBTN;
